import { render } from "./radiology_index.vue?vue&type=template&id=2b5ad7af&scoped=true"
import script from "./radiology_index.vue?vue&type=script&lang=js"
export * from "./radiology_index.vue?vue&type=script&lang=js"

import "./radiology_index.vue?vue&type=style&index=0&id=2b5ad7af&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5ad7af"]])

export default __exports__